module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/flux-capacitor-bd350.svg";